import { render, staticRenderFns } from "./index-jthnt.vue?vue&type=template&id=ddca4a8a&scoped=true&"
import script from "./index-jthnt.vue?vue&type=script&lang=js&"
export * from "./index-jthnt.vue?vue&type=script&lang=js&"
import style0 from "./index-jthnt.vue?vue&type=style&index=0&id=ddca4a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddca4a8a",
  null
  
)

export default component.exports